<template>
  <quill-editor
    class="editor"
    :class="{
      'is-focused': editorFocused,
    }"
    ref="quillEditor"
    :value="value"
    @change="onEditorChange"
    :options="options"
    @ready="onEditorReady($event)"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
  />
</template>

<script>
import Quill from "quill";

import ImageUploader from "quill-image-uploader";
Quill.register("modules/imageUploader", ImageUploader);

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default Vue.extend({
  components: {
    quillEditor,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    editorOptions: {
      type: Object,
      default: () => {},
    },
    contentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editorFocused: false,
      imagesToRemove: [],
    };
  },
  computed: {
    editor() {
      return this.$refs.quillEditor.quill;
    },
    options() {
      return _.merge(
        {
          modules: {
            toolbar: _.get(this.editorOptions, "modules.toolbar", [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["clean"],
              ["link", "image", "video"],
            ]),
            imageUploader: {
              upload: (file) => {
                this.$emit("image-uploading", file);

                return new Promise((resolve, reject) => {
                  let data = new FormData();
                  data.append("model_id", this.contentId);
                  data.append("model_type", "article_content");
                  data.append("file", file);

                  axios
                    .post(`/api/attachments`, data)
                    .then(({ data }) => {
                      resolve(data.url);
                      this.$emit("image-upload", data.url);
                    })
                    .catch((error) => {
                      reject(error);
                    });
                });
              },
            },
          },
        },
        this.editorOptions
      );
    },
  },
  methods: {
    onEditorChange(value) {
      this.$emit("change", value);
    },
    onEditorBlur(editor) {
      this.editorFocused = false;
      this.$emit("blur", editor);
    },
    onEditorFocus(editor) {
      this.editorFocused = true;
      this.$emit("focus", editor);
    },
    onEditorReady(editor) {
      this.$emit("ready", editor);

      editor.on("text-change", this.onImageRemove);
    },
    onImageRemove(delta, oldContents, source) {
      let currrentContents = this.editor.getContents();
      let diff = currrentContents.diff(oldContents);
      let diffUndo = oldContents.diff(currrentContents);

      let removeImageOps = _.filter(diff.ops, (op) =>
        _.has(op, "insert.image")
      );

      let insertImageOps = _.filter(diffUndo.ops, (op) =>
        _.has(op, "insert.image")
      );

      let removeImageList = _.map(removeImageOps, "insert.image");
      let insertImageList = _.map(insertImageOps, "insert.image");

      for (let image of insertImageList) {
        this.imagesToRemove.splice(_.indexOf(this.imagesToRemove, image), 1);
      }

      this.imagesToRemove.push(...removeImageList);

      if (removeImageList.length > 0 || insertImageList.length > 0) {
        this.$emit("image-remove", this.imagesToRemove);
      }
    },
  },
});
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "~bulma/sass/elements/form.sass";

.quill-editor {
  box-shadow: $input-shadow;
  border-radius: $input-radius;
  background-color: $input-background-color;
  border: 1px solid $input-border-color;
  &:hover {
    border-color: $input-hover-border-color;
  }
  &.is-focused,
  &.is-active {
    border-color: $input-focus-border-color;
    box-shadow: $input-focus-box-shadow-size $input-focus-box-shadow-color;
  }
}

.ql-toolbar,
.ql-container {
  border: none !important;
}

.ql-editor {
  min-height: 10em;
  p:not(:first-of-type) {
    margin-top: 1em;
  }
}

.ql-editor.ql-blank::before {
  font-style: normal;
  color: rgba(0, 0, 0, 0.1);
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/QuillEditor.vue